<section class="mbtop">
    <article class="account">
      <div class="container">
  
  
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-12">
          </div>
          <div class="col-lg-9 col-md-9 col-sm-12">
            <div class="col-lg-6 col-xs-6 col-md-6 d-flex w-b">
              <h2> Horoscope Report Orders History</h2>
            </div>
            <div class="" *ngIf="reportData?.length>0">
              <div class="col-lg-12 col-md-12 col-sm-12  border card mb-2" *ngFor="let item of reportData">
                <div class="profile">
                  <div class="profile-img">
                    <img src="/assets/image/modified.svg" alt="">
                  </div>
                  <div class="info">
                    <div class="row">
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Advisor : </strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p>{{item?.astrologerName}}</p>
                      </div>
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Total Deduction :</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p>{{gS.currencySign}} {{item?.orderPrice}}</p>
                      </div>
  
                    </div>
                    <div class="row">
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Order Time:</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p> <span>{{item.orderDate|
                            date:'d-m-Y'}} </span> | <span> {{item.orderDate|
                            date:'hh:mm a'}}</span> </p>
                      </div>
                      <div class="col-lg-2 col-md-6 col-sm-6">
                        <p><strong>Status</strong></p>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-6">
                        <p>{{item?.isVerifedByAdmin==true?'Completed':'Pending'}}</p>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="button">
                  <button *ngIf="item?.isVerifedByAdmin==true" class="rate-btn " (click)="showMoadl(item)">{{item?.customerRating>0?'View Rating':'Rate Us'}}</button>
                  <button type="button" class="btn btn-info" (click)="viewHoroscopreOrder(item)" data-bs-target="#exampleModalToggleReport" data-bs-toggle="modal">View
                    Order</button>
                </div>
  
  
                <!-- <div class="other">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                      <span class="ftW">Astrologer : </span><span>{{item.astrologerName}}
                      </span>
                    </div>
  
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <span class="ftW">Deduction : </span><span>&#x20B9; {{item?.orderPrice}}
                      </span>
                    </div>
  
                  </div>
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                      <span class="ftW">Date & Time : </span> <span>{{item.orderDate| date:'d/m/Y'}}</span>
                    </div>
  
                  </div>
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 text-end">
                      <button type="button" class="btn btn-info " style="margin: auto;"
                        (click)="reviewHoroscopreOrder(item)">View
                        Order</button>
                    </div>
  
                  </div>
  
                </div> -->
              </div>
            </div>
            <div class="noDataFound" *ngIf="reportData?.length==0">
              <p>No Data Found</p>
            </div>
          </div>
        </div>
      </div>
  
       <!-- Rate Consulatation Popup -->
       <div #rateReportConsulatation class="modal fade" id="rateReportConsulatation" tabindex="-1" aria-labelledby="rateReportConsulatationLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="rateReportConsulatationLabel">Rate Consultation</h5>
              <button type="button" class="btn-close" (click)="closeMoadl()" aria-label="Close">
                <img src="../../assets/images/close.svg" alt="">
              </button>
            </div>
            <div class="modal-body">
              <div class="stars">
                <ngx-stars *ngIf="orderData" customSize="20px" [readonly]="orderData?.customerRating>0" (ratingOutput)="onRatingSet($event)" [color]="'#eb9534'" [maxStars]="5"
                  [initialStars]="orderData?.customerRating>0?orderData?.customerRating:0"></ngx-stars>
              </div>
              <div class="form-control rating">
                <label class="rate" for="rate">
                  <textarea [readOnly]="orderData?.customerReview" [(ngModel)]="customerReview" type="text" name="" id="rate" placeholder="Describe your experience with Advisor in few words..."></textarea> 
                </label>
              </div>
            </div>
            <div class="modal-footer justify-content-center" *ngIf="orderData?.customerRating==0">
              <button [disabled]="customerRating==0 || customerReview=='' || customerReview==null" type="button" class="btn btn-apply" (click)="submitReview()">Submit</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Rate Consulatation Popup end-->
    </article>
  </section>
  <app-view-horoscope-report *ngIf="horoscopreReportOrderId" [orderId]="horoscopreReportOrderId"
    (close)="eventClosePalmOrder($event)"></app-view-horoscope-report>